'use client'

import { AppLayoutProvider } from '../providers/AppLayoutProvider'
import { StoreProvider } from '../providers/StoreProvider'
import { PageFooter } from './PageFooter/PageFooter'
import { PageHeader } from './PageHeader/PageHeader'
import type { AppLayoutContextValue } from '../providers/AppLayoutProvider'
import type { PropsWithChildren } from 'react'

export type AppLayoutProps = PropsWithChildren & AppLayoutContextValue

export const AppLayout = ({ children, ...props }: AppLayoutProps) => {
  return (
    <StoreProvider>
      <AppLayoutProvider {...props}>
        <PageHeader />

        <div
          className="lg:mt-[107px] 2xl:mt-[113px]"
          data-testid="root-layout-children-container"
        >
          {children}
        </div>

        <PageFooter />
      </AppLayoutProvider>
    </StoreProvider>
  )
}
